import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InnerCircleLicenseState } from '@models/app/helpers.model';
import { SiqPopupHelper } from '@shared/utils/helpers/siq-popup.helper';
import { Observable, catchError, map, throwError } from 'rxjs';
import { EnvironmentsService } from './environments.service';
import { MixpanelService } from './mixpanel.service';
import { SiqApiService } from './siq-api.service';
import { SplashScreenService } from './splash-screen.service';

@Injectable({
  providedIn: 'root'
})
export class TacoService extends SiqApiService {

  constructor(
    httpClient: HttpClient,
    environmentService: EnvironmentsService,
    mixpanelService: MixpanelService,
    siqPopupHelper: SiqPopupHelper,
    splashScreenService: SplashScreenService) {
    super(httpClient, environmentService, mixpanelService, siqPopupHelper, splashScreenService);
  }

  getPrivacyPolicy(): Observable<string> {
    return this.makeTextRequest('privacy-policy').pipe(
      map((response : string | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }

  getInnerCircleLicenseState(): Observable<InnerCircleLicenseState> {
    return this.makeSleepNumberRequest<InnerCircleLicenseState, object>('terms', {}, 'GET').pipe(
      map((response : InnerCircleLicenseState | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }

  acceptEulaAndPrivacy(): Observable<object> {
    return this.makeSiqRequest<object, object>('privacy-policy-license', 'siq', {}, 'PUT', false).pipe(
      map((response : object | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }

  acceptEula(): Observable<object> {
    return this.makeSiqRequest<object, object>('license', 'siq', {}, 'PUT', false).pipe(
      map((response : object | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }

  acceptPrivacyPolicy(): Observable<object> {
    return this.makeSiqRequest<object, object>('privacy-policy/jwt', 'siq', {}, 'PUT', false).pipe(
      map((response : object | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }

  acceptInnerCircle(): Observable<object> {
    return this.makeSleepNumberRequest<object, Record<string, boolean>>('terms', { accepted: true }, 'PATCH').pipe(
      map((response : object | HttpErrorResponse) => {
        if(response instanceof HttpErrorResponse) {
          throw response;
        }
        return response;
      }),
      catchError((error: HttpErrorResponse) => throwError(() => error))
    )
  }
}
